import { Component, OnChanges, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Email } from 'src/app/models/email';
import { User } from 'src/app/models/user';
import { first } from 'rxjs/operators';
import { Constants } from 'src/app/helpers/constants';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { EmailService } from 'src/app/services/email.service';
import { UserService } from 'src/app/services/user.service';
import { Job, Status } from 'src/app/models';
import { JobService, UtilityService } from 'src/app/services';
import { JobCandidate } from 'src/app/models/job-candidate';
import { HearAbout } from 'src/app/models/hear-about';
import { Router } from '@angular/router';
import { HearAboutService } from 'src/app/services/hear-about.service';
import { CountryService } from 'src/app/services/country.service';
import { CandidateService } from 'src/app/services/candidates.service';
import { JobCandidateService } from 'src/app/services/job-candidate.service';
import { HttpErrorResponse, HttpEventType } from '@angular/common/http';

@Component({
  selector: 'app-applyjob',
  templateUrl: './applyjob.component.html',
  styleUrls: ['./applyjob.component.scss']
})
export class ApplyjobComponent implements OnInit, OnChanges {
  env = environment;
  applyjobForm: FormGroup;
  submitted = false;
  loader = false;
  message = "";
  classType = "";
  messageType = ""
  public siteKey: any;
  job: Job;
  jobId: number = 0;
  progress: number;
  countries: any[] = [];
  hearAbouts: HearAbout[];
  filePath: string = "";
  uploadMessage: string;
  constructor(
    private formBuilder: FormBuilder,
    private jobCandidateService: JobCandidateService,
    private userService: UserService,
    private jobService: JobService,
    private router: Router,
    private candidateService: CandidateService,
    private hearAboutService: HearAboutService,
    private countryService: CountryService) { }
  ngOnInit(): void {
    this.applyjobForm = this.formBuilder.group(
      {
        firstName: ["", { validators: [Validators.required], updateOn: "change" }],
        lastName: ["", { validators: [Validators.required], updateOn: "change" }],
        email: ["", { validators: [Validators.required, Validators.email], updateOn: 'change' }],
        totalExperience: ["", { validators: [Validators.required], updateOn: "change" }],
        skills: ["", { validators: [Validators.required], updateOn: "change" }],
        referralName: [""],
        cvPath: [this.filePath],
        hearAboutId: ["", { validators: [Validators.required], updateOn: "change" }],
        statusId: ["1", { validators: [Validators.required], updateOn: "change" }],
        countryId: ["", { validators: [Validators.required], updateOn: "change" }],
        recaptcha: ["", { validators: [Validators.required], updateOn: "change" }]
      });
    let jobIdCheck = this.router.url.split('/').pop();
    this.jobId = jobIdCheck == undefined ? 0 : parseInt(jobIdCheck) || 0;

    this.siteKey = environment.siteKey;

    this.fetchData();
  }
  ngOnChanges(): void {
  }
  fetchData() {
    this.countryService.getAll()
      .subscribe(
        data => {
          this.countries = data;
          const btn = document.getElementById('countryId');
          btn.style.display = 'block';
          const select = document.getElementsByClassName('nice-select');
          for (let index = 0; index < select.length; index++) {
            select[index].remove();
          }
        },
        error => {
        });

    this.hearAboutService.getAll()
      .subscribe(
        data => {
          this.hearAbouts = data;
          const btn = document.getElementById('hearAbouts');
          btn.style.display = 'block';
          const select = document.getElementsByClassName('nice-select');
          for (let index = 0; index < select.length; index++) {
            select[index].remove();
          }
        },
        error => {
        });
  }
  get f() { return this.applyjobForm.controls; }
  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.applyjobForm.invalid) {
      return;
    }
    if (this.filePath == "") {
      alert("CV not uploaded");
      return;
    }
    this.loader = true;

    let userdata: User = new User;
    userdata.userName = environment.username;
    userdata.password = environment.password;
    this.userService.authenticate(userdata)
      .pipe(first())
      .subscribe(
        userdata => {
          localStorage.setItem('currentSaraAppTokenUser', JSON.stringify(userdata));

          this.applyjobForm.patchValue({ cvPath: this.filePath });
          this.candidateService.create(this.applyjobForm.value)
            .pipe(first())
            .subscribe(
              data => {
                let jobCandidate: JobCandidate = new JobCandidate;
                jobCandidate.jobId = this.jobId
                jobCandidate.candidateId = data.id
                this.submitRelationship(jobCandidate);
                this.classType = "alert-success";
                this.messageType = "Success";
                this.message = "Thank you! Your data has been submitted. Please wait for the response from support team.";
                this.applyjobForm.reset();
                this.submitted = false;
                this.loader = false;
                localStorage.removeItem('currentSaraAppTokenUser');
                const input = document.getElementById('cvfile') as HTMLInputElement | null;
                input.value = "";
              },
              error => {
                this.classType = "alert-danger";
                this.messageType = "Failed";
                this.message = "Sorry! We were unable to submit your data. Please try after sometime or email to: ";
                localStorage.removeItem('currentSaraAppTokenUser');
              });
        },
        error => {
          this.classType = "alert-danger";
          this.messageType = "Failed";
          this.message = "Sorry! We were unable to submit your query. Please try after sometime or email to: ";
        });
  }
  submitRelationship(jobCandidate: JobCandidate) {
    this.jobCandidateService.create(jobCandidate)
      .pipe(first())
      .subscribe(
        data => {
          localStorage.removeItem('currentSaraAppTokenUser');
        },
        error => {
          localStorage.removeItem('currentSaraAppTokenUser');
        });
  }

  uploadFile = (files) => {
    if (files.length === 0) {
      return;
    }
    if (files[0].size > 1048576) {
      alert("File is too big!");
      const input = document.getElementById('cvfile') as HTMLInputElement | null;
      input.value = "";
    };
    let fileToUpload = <File>files[0];

    var regexp;
    var extension = fileToUpload.name.substring(fileToUpload.name.lastIndexOf('.'));
    if ((extension.toLowerCase() == ".pdf") ||
      (extension.toLowerCase() == ".doc") ||
      (extension.toLowerCase() == ".docx")) {
      const formData = new FormData();
      formData.append('file', fileToUpload, fileToUpload.name);
      let userdata: User = new User;
      userdata.userName = environment.username;
      userdata.password = environment.password;
      this.userService.authenticate(userdata)
        .pipe(first())
        .subscribe(
          userdata => {
            localStorage.setItem('currentSaraAppTokenUser', JSON.stringify(userdata));
            this.jobCandidateService.uploadFile(formData)
              .subscribe({
                next: (event) => {
                  if (event.type === HttpEventType.UploadProgress)
                    this.progress = Math.round(100 * event.loaded / event.total);
                  else if (event.type === HttpEventType.Response) {
                    this.uploadMessage = 'Upload success.';
                    this.filePath = event.body["dbPath"];
                  }
                },
                error: (err: HttpErrorResponse) => console.log(err)
              });
          },
          error => {
            this.classType = "alert-danger";
            this.messageType = "Failed";
            this.message = "Sorry! We were unable to submit your query. Please try after sometime or email to: ";
          });
    }
    else {
      alert('File type not supported');
      const input = document.getElementById('cvfile') as HTMLInputElement | null;
      input.value = "";
    }
  }
}
